import { PureComponent } from 'react';
import { noop } from 'lodash';

export default function withBlurTransforms(ComponentToWrap) {
  class WithBlurTransforms extends PureComponent {
    static defaultProps = {
      onBlur: noop,
      setFieldValue: noop,
      blurTransform: (value) => value,
    };

    onBlur = (...rest) => {
      // @ts-expect-error TS(2339): Property 'blurTransform' does not exist on type 'R... Remove this comment to see the full error message
      const transformedValue = this.props.blurTransform(this.props.value);

      // @ts-expect-error TS(2339): Property 'setFieldValue' does not exist on type 'R... Remove this comment to see the full error message
      this.props.setFieldValue(this.props.name, transformedValue);

      // @ts-expect-error TS(2339): Property 'onBlur' does not exist on type 'Readonly... Remove this comment to see the full error message
      this.props.onBlur(...rest);
    };

    render() {
      // @ts-expect-error TS(2339): Property 'blurTransform' does not exist on type 'R... Remove this comment to see the full error message
      const { blurTransform, setFieldValue, ...rest } = this.props;

      return <ComponentToWrap {...rest} onBlur={this.onBlur} />;
    }
  }

  return WithBlurTransforms;
}
